import React from "react";
import theme from "theme";
import { Theme, Text, Button, Box, Section, Em, Image, Icon, List } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
import { MdCheckCircle } from "react-icons/md";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"index"} />
		<Helmet>
			<title>
				STACK
			</title>
			<meta name={"description"} content={"The Addictive Block Stacking Game"} />
			<meta property={"og:title"} content={"STACK"} />
			<meta property={"og:description"} content={"The Addictive Block Stacking Game"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image1_0%20%284%29.jpg?v=2025-01-03T10:32:36.098Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image1_0%20%284%29.jpg?v=2025-01-03T10:32:36.098Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image1_0%20%284%29.jpg?v=2025-01-03T10:32:36.098Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image1_0%20%284%29.jpg?v=2025-01-03T10:32:36.098Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image1_0%20%284%29.jpg?v=2025-01-03T10:32:36.098Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image1_0%20%284%29.jpg?v=2025-01-03T10:32:36.098Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image1_0%20%284%29.jpg?v=2025-01-03T10:32:36.098Z"} />
		</Helmet>
		<Components.Header4>
			<Override slot="link2" />
			<Override slot="link3" />
		</Components.Header4>
		<Section
			padding="40px 0 40px 0"
			background="linear-gradient(180deg,rgba(65, 140, 134, 0.97) 0%,rgba(1, 1, 1, 0.63) 50%,rgba(65, 140, 134, 0.94) 98.6%) 0 0 no-repeat,url(https://uploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image1_0.jpg?v=2025-01-03T10:32:36.103Z) center center/cover no-repeat"
			min-height="100vh"
			lg-padding="80px 0 80px 0"
			md-padding="96px 0 96px 0"
			sm-padding="72px 0 96px 0"
		>
			<Override slot="SectionContent" flex-direction="row" flex-wrap="wrap" />
			<Box
				display="flex"
				width="100%"
				flex-direction="column"
				justify-content="center"
				align-items="center"
				lg-width="100%"
				lg-align-items="center"
				lg-margin="0px 0px 0px 0px"
				sm-margin="0px 0px 40px 0px"
				margin="0px 0px 0px 0px"
				padding="0px 0px 0px 0px"
				md-margin="0px 0px 0px 0px"
				sm-padding="0px 0px 0px 0px"
			>
				<Text
					margin="0px 0px 24px 0px"
					color="--light"
					font="--headline1"
					lg-text-align="center"
					sm-font="normal 700 42px/1.2 &quot;Source Sans Pro&quot;, sans-serif"
					text-align="center"
					width="80%"
					md-font="normal 700 42px/1.2 &quot;Source Sans Pro&quot;, sans-serif"
					sm-width="100%"
				>
					STACK
				</Text>
				<Text
					margin="0px 0px 32px 0px"
					color="#FFFFFF"
					font="--headline3"
					lg-text-align="center"
					text-align="center"
				>
					The Addictive Block Stacking Game
				</Text>
				<Button
					border-style="solid"
					border-width="1px"
					border-color="--color-primary"
					border-radius="13px"
					background="--primaryGradient"
					type="link"
					text-decoration-line="initial"
					href="https://play.google.com/store/apps/details?id=com.ketchapp.stack&hl=en"
				>
					Download
				</Button>
			</Box>
		</Section>
		<Section padding="40px 0 40px 0" background="--color-dark" quarkly-title="Description-11">
			<Override
				slot="SectionContent"
				flex-wrap="wrap"
				max-width="1440px"
				align-items="flex-start"
				flex-direction="row"
			/>
			<Box border-color="--color-light" width="100%" border-width="0px 0px 1px 0px" border-style="solid">
				<Text margin="0px 0px 2vh 0px" color="--light" font="--lead">
					Game Features
				</Text>
			</Box>
			<Box width="100%" margin="3vw 0px 0px 0px">
				<Text
					margin="0px 0px 0px 0px"
					font="--headline2"
					color="--light"
					letter-spacing="-.05em"
					lg-font="normal 400 70px/1.1em &quot;Inter&quot;, sans-serif"
					sm-font="normal 400 40px/1.1em &quot;Inter&quot;, sans-serif"
				>
					One of the most striking features of{" "}
					<Em>
						Stack
					</Em>
					{" "}is its minimalist design. The game features a sleek, clean aesthetic that focuses on the blocks themselves, with vibrant neon colors standing out against a dark background. The colors are dynamic, and the blocks change as you progress through levels, creating a mesmerizing experience as you stack higher.
				</Text>
			</Box>
			<Box
				margin="156px 0px 100px 0px"
				lg-margin="56px 0px 30px 0px"
				md-display="none"
				width="33.333%"
				padding="20px 20px 20px 20px"
			/>
			<Box
				width="33.333%"
				padding="20px 20px 20px 20px"
				margin="156px 0px 50px 0px"
				lg-margin="56px 0px 30px 0px"
				md-width="50%"
				sm-margin="20px 0px 20px 0px"
				sm-width="100%"
			>
				<Text margin="0 0px 0px 0px" font="--lead" color="--light">
					<Em>
						Stack
					</Em>
					{" "}is an endless game, meaning there’s no final level or end goal. Your mission is to stack as high as you can before the stack falls apart. This endless nature allows you to play at your own pace and enjoy the game for as long as you like.
				</Text>
			</Box>
			<Box
				sm-width="100%"
				width="33.333%"
				padding="20px 20px 20px 20px"
				margin="156px 0px 50px 0px"
				lg-margin="56px 0px 30px 0px"
				md-width="50%"
				sm-margin="20px 0px 20px 0px"
			>
				<Text margin="0 0px 0px 0px" font="--lead" color="--light">
					The game is incredibly easy to pick up, with simple tap-based controls. Tap the screen to place a block, and let the game’s mechanics do the rest. There’s no need for complex inputs or tutorials. Just tap, stack, and enjoy the game.
				</Text>
			</Box>
			<Box
				md-width="50%"
				sm-margin="20px 0px 20px 0px"
				sm-width="100%"
				width="33.333%"
				padding="20px 20px 20px 20px"
				margin="156px 0px 100px 0px"
				lg-margin="56px 0px 30px 0px"
			>
				<Text font="--lead" color="--light" margin="0 0px 0px 0px">
					As you progress, the difficulty of the game gradually increases. The speed of the blocks increases, and the size of the blocks gets smaller. This incremental challenge ensures that the game remains engaging and fun without ever feeling impossible.
				</Text>
			</Box>
			<Box
				md-width="50%"
				sm-margin="20px 0px 20px 0px"
				sm-width="100%"
				width="33.333%"
				padding="20px 20px 20px 20px"
				margin="156px 0px 100px 0px"
				lg-margin="56px 0px 30px 0px"
			>
				<Text margin="0 0px 0px 0px" font="--lead" color="--light">
					The neon-colored blocks on a dark background create a visually striking effect that’s not only easy on the eyes but also highly satisfying. The simple yet attractive design ensures that you stay focused on the task at hand – stacking the blocks – while still enjoying a stunning visual experience.
				</Text>
			</Box>
			<Box
				md-width="50%"
				sm-margin="20px 0px 20px 0px"
				sm-width="100%"
				width="33.333%"
				padding="20px 20px 20px 20px"
				margin="156px 0px 100px 0px"
				lg-margin="56px 0px 30px 0px"
			>
				<Text margin="0 0px 0px 0px" font="--lead" color="--light">
					<Em>
						Stack
					</Em>
					{" "}doesn’t require an internet connection to play, making it perfect for playing on the go. Whether you’re waiting for a bus or taking a quick break, you can jump into the game anytime and anywhere.
				</Text>
			</Box>
		</Section>
		<Section padding="90px 0 100px 0" background="linear-gradient(180deg,rgba(65, 140, 134, 0.97) 0%,rgba(1, 1, 1, 0.63) 50%,rgba(65, 140, 134, 0.94) 98.6%) 0 0 no-repeat,rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%282%29.jpg?v=2025-01-03T10:32:36.091Z) 0% 0% /cover no-repeat scroll padding-box" quarkly-title="Price-18">
			<Override slot="SectionContent" />
			<Text margin="0px 0px 20px 0px" text-align="center" font="--headline2" color="--light">
				How to Play
			</Text>
			<Text
				margin="0px 0px 70px 0px"
				text-align="center"
				font="--lead"
				color="--light"
				width="700px"
				align-self="center"
				md-align-self="auto"
				max-width="100%"
			>
				When you start playing{" "}
				<Em>
					Stack
				</Em>
				, blocks begin to move from side to side on the screen. As the blocks move, you must tap the screen at the perfect moment to drop the block onto the stack. Each block perfectly placed adds another layer to your growing tower. The more blocks you stack, the higher the tower becomes.
			</Text>
			<Box
				min-width="100px"
				min-height="100px"
				display="grid"
				grid-template-columns="repeat(3, 1fr)"
				grid-gap="0 34px"
				lg-grid-template-columns="1fr"
				lg-grid-gap="35px 0"
			>
				<Box
					min-width="100px"
					min-height="100px"
					display="flex"
					flex-direction="column"
					align-items="center"
					background="--color-light"
					border-radius="25px"
					justify-content="space-between"
				>
					<Box
						min-width="100px"
						min-height="100px"
						display="flex"
						flex-direction="column"
						align-items="center"
					>
						<Image
							src="https://uploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0.jpg?v=2025-01-03T10:32:36.106Z"
							display="block"
							width="100%"
							height="300px"
							object-fit="cover"
							border-radius="25px 25px 0 0"
							srcSet="https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0.jpg?v=2025-01-03T10%3A32%3A36.106Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0.jpg?v=2025-01-03T10%3A32%3A36.106Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0.jpg?v=2025-01-03T10%3A32%3A36.106Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0.jpg?v=2025-01-03T10%3A32%3A36.106Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0.jpg?v=2025-01-03T10%3A32%3A36.106Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0.jpg?v=2025-01-03T10%3A32%3A36.106Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0.jpg?v=2025-01-03T10%3A32%3A36.106Z&quality=85&w=3200 3200w"
							sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
						/>
						<Box
							min-width="100px"
							min-height="100px"
							margin="25px 0px 25px 0px"
							display="flex"
							flex-direction="column"
							align-items="center"
							padding="0px 25px 0px 25px"
						>
							<Text margin="0px 0px 10px 0px" color="--darkL1" text-align="center" font="normal 400 20px/1.5 --fontFamily-sansHelvetica">
								Stack the Blocks
							</Text>
							<Text margin="0px 0px 0px 0px" color="--darkL1" font="normal 300 16px/1.5 --fontFamily-sansTrebuchet" text-align="left">
								Tap the screen at the right moment to drop each block on top of the stack. Be precise – the better your timing, the higher your stack will grow.
								<br />
								<br />
							</Text>
						</Box>
					</Box>
					<Button
						margin="0px 0px 30px 0px"
						background="--color-primary"
						href="https://play.google.com/store/apps/details?id=com.cornago.stefano.lapse&hl=en"
						type="link"
						text-decoration-line="initial"
					>
						Download
					</Button>
				</Box>
				<Box
					min-width="100px"
					min-height="100px"
					display="flex"
					flex-direction="column"
					align-items="center"
					background="--color-light"
					border-radius="25px"
					justify-content="space-between"
				>
					<Box
						min-width="100px"
						min-height="100px"
						display="flex"
						flex-direction="column"
						align-items="center"
					>
						<Image
							src="https://uploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%282%29.jpg?v=2025-01-03T10:32:36.091Z"
							display="block"
							width="100%"
							height="300px"
							object-fit="cover"
							border-radius="25px 25px 0 0"
							srcSet="https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%282%29.jpg?v=2025-01-03T10%3A32%3A36.091Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%282%29.jpg?v=2025-01-03T10%3A32%3A36.091Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%282%29.jpg?v=2025-01-03T10%3A32%3A36.091Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%282%29.jpg?v=2025-01-03T10%3A32%3A36.091Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%282%29.jpg?v=2025-01-03T10%3A32%3A36.091Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%282%29.jpg?v=2025-01-03T10%3A32%3A36.091Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%282%29.jpg?v=2025-01-03T10%3A32%3A36.091Z&quality=85&w=3200 3200w"
							sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
						/>
						<Box
							min-width="100px"
							min-height="100px"
							margin="25px 0px 25px 0px"
							display="flex"
							flex-direction="column"
							align-items="center"
							padding="0px 25px 0px 25px"
						>
							<Text margin="0px 0px 10px 0px" color="--darkL1" text-align="center" font="normal 400 20px/1.5 --fontFamily-sansHelvetica">
								Challenge Yourself
							</Text>
							<Text margin="0px 0px 0px 0px" color="--darkL1" font="normal 300 16px/1.5 --fontFamily-sansTrebuchet" text-align="left">
								Keep stacking and see how high you can go. Challenge your friends or yourself to beat your previous high score. Can you make it to the top?
							</Text>
						</Box>
					</Box>
					<Button
						margin="0px 0px 30px 0px"
						background="--color-primary"
						href="https://play.google.com/store/apps/details?id=com.cornago.stefano.lapse&hl=en"
						type="link"
						text-decoration-line="initial"
					>
						Download
					</Button>
				</Box>
				<Box
					min-width="100px"
					min-height="100px"
					display="flex"
					flex-direction="column"
					align-items="center"
					background="--color-light"
					border-radius="25px"
					justify-content="space-between"
				>
					<Box
						min-width="100px"
						min-height="100px"
						display="flex"
						flex-direction="column"
						align-items="center"
					>
						<Image
							src="https://uploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image1_0%20%284%29.jpg?v=2025-01-03T10:32:36.098Z"
							display="block"
							width="100%"
							height="300px"
							object-fit="cover"
							border-radius="25px 25px 0 0"
							srcSet="https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image1_0%20%284%29.jpg?v=2025-01-03T10%3A32%3A36.098Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image1_0%20%284%29.jpg?v=2025-01-03T10%3A32%3A36.098Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image1_0%20%284%29.jpg?v=2025-01-03T10%3A32%3A36.098Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image1_0%20%284%29.jpg?v=2025-01-03T10%3A32%3A36.098Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image1_0%20%284%29.jpg?v=2025-01-03T10%3A32%3A36.098Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image1_0%20%284%29.jpg?v=2025-01-03T10%3A32%3A36.098Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image1_0%20%284%29.jpg?v=2025-01-03T10%3A32%3A36.098Z&quality=85&w=3200 3200w"
							sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
						/>
						<Box
							min-width="100px"
							min-height="100px"
							margin="25px 0px 25px 0px"
							display="flex"
							flex-direction="column"
							align-items="center"
							padding="0px 25px 0px 25px"
						>
							<Text margin="0px 0px 10px 0px" color="--darkL1" text-align="center" font="normal 400 20px/1.5 --fontFamily-sansHelvetica">
								Enjoy the Game
							</Text>
							<Text margin="0px 0px 0px 0px" color="--darkL1" font="normal 300 16px/1.5 --fontFamily-sansTrebuchet" text-align="left">
								Relax, focus, and enjoy the game’s smooth animations, minimalist design, and rhythmic gameplay.
							</Text>
						</Box>
					</Box>
					<Button
						margin="0px 0px 30px 0px"
						background="--color-primary"
						href="https://play.google.com/store/apps/details?id=com.cornago.stefano.lapse&hl=en"
						type="link"
						text-decoration-line="initial"
					>
						Download
					</Button>
				</Box>
			</Box>
		</Section>
		<Section
			padding="100px 0"
			sm-padding="40px 0"
			sm-min-height="auto"
			display="flex"
			background="rgba(0, 0, 0, 0) radial-gradient(circle at center,--color-green 0%,--color-dark 100%) 0% 0% /auto repeat scroll padding-box"
			quarkly-title="Advantages/Features-30"
		>
			<Override
				slot="SectionContent"
				flex-direction="row"
				flex-wrap="wrap"
				grid-gap="5%"
				padding="60px 40px"
				sm-padding="30px 30px 60px 30px"
				background="rgba(255, 255, 255, 0.06) radial-gradient(circle at center,rgba(255, 255, 255, 0.01) 0%,rgba(255, 255, 255, 0.02) 100%)"
				border-radius="30px"
				border-width="1px"
				border-style="solid"
				border-color="rgba(255, 255, 255, 0.03)"
			/>
			<Box
				display="flex"
				flex="0 0 40%"
				lg-flex="1 1 100%"
				justify-content="flex-end"
				overflow-y="hidden"
				overflow-x="hidden"
				lg-width="100%"
				align-items="center"
				lg-justify-content="flex-start"
				lg-padding="0px 0px 0px 0px"
			>
				<Image
					height="23em"
					width="23em"
					min-height="260px"
					lg-width="auto"
					lg-height="auto"
					object-fit="cover"
					src="https://uploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%281%29.jpg?v=2025-01-03T10:32:36.102Z"
					display="block"
					border-radius="20px"
					srcSet="https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%281%29.jpg?v=2025-01-03T10%3A32%3A36.102Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%281%29.jpg?v=2025-01-03T10%3A32%3A36.102Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%281%29.jpg?v=2025-01-03T10%3A32%3A36.102Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%281%29.jpg?v=2025-01-03T10%3A32%3A36.102Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%281%29.jpg?v=2025-01-03T10%3A32%3A36.102Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%281%29.jpg?v=2025-01-03T10%3A32%3A36.102Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6776e01a41a0cf0024a6cdad/images/image0_0%20%281%29.jpg?v=2025-01-03T10%3A32%3A36.102Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
				/>
			</Box>
			<Box
				display="flex"
				flex="1 1 55%"
				flex-direction="column"
				justify-content="flex-start"
				lg-width="100%"
				lg-align-items="flex-start"
				lg-margin="0"
				padding="30px 0px 0 0"
				lg-flex-direction="row"
				lg-flex-wrap="wrap"
			>
				<Text
					as="h1"
					margin="0px"
					font="normal 600 2.3em/1.5 --fontFamily-sans"
					color="--light"
					width="100%"
					md-width="100%"
					md-margin="0px 0px 26px 0px"
					md-padding="0px 0px 0px 0px"
					sm-font="normal 600 30px/1.2 --fontFamily-sans"
				>
					Why You Should Play{" "}
					<Em>
						Stack
					</Em>
				</Text>
				<Text
					as="p"
					margin="1.2em 0 0 0"
					font="normal 100 20px/1.5 --fontFamily-sans"
					font-size="1.2em"
					font-weight="300"
					color="--light"
					width="100%"
					md-width="100%"
					md-margin="0px 0px 0px 0px"
					md-padding="0px 0px 0px 0px"
					lg-max-width="640px"
				>
					There are many reasons why{" "}
					<Em>
						Stack
					</Em>
					{" "}is a must-play game for mobile users. Here’s why you should give it a try:
				</Text>
				<Box
					display="flex"
					flex-direction="row"
					grid-gap="18px"
					margin="30px 0px 0px 0px"
					font="400 1.1em --fontFamily-sans"
					lg-width="100%"
					lg-justify-content="flex-start"
					flex-wrap="wrap"
					color="--light"
					sm-margin="24px 0 0 0"
					lg-margin="32px 0px 0px 0px"
				>
					<List
						as="ul"
						padding="0"
						margin="0"
						list-style-type="none"
						display="flex"
						flex-direction="column"
						grid-gap="18px"
						lg-max-width="640px"
					>
						<Box margin="0px 0px 0px 0px" display="flex" grid-gap="10px">
							<Icon display="block" category="md" icon={MdCheckCircle} size="20px" />
							<Text padding="0" margin="0">
								Addictive Gameplay
							</Text>
						</Box>
						<Box margin="0px 0px 0px 0px" display="flex" grid-gap="10px">
							<Icon display="block" category="md" icon={MdCheckCircle} size="20px" />
							<Text padding="0" margin="0">
								Satisfying Experience
							</Text>
						</Box>
						<Box margin="0px 0px 0px 0px" display="flex" grid-gap="10px">
							<Icon display="block" category="md" icon={MdCheckCircle} size="20px" />
							<Text padding="0" margin="0">
								Perfect for Quick Sessions
							</Text>
						</Box>
					</List>
					<List
						as="ul"
						padding="0"
						margin="0"
						list-style-type="none"
						display="flex"
						flex-direction="column"
						grid-gap="18px"
						lg-max-width="640px"
					>
						<Box margin="0px 0px 0px 0px" display="flex" grid-gap="10px">
							<Icon display="block" category="md" icon={MdCheckCircle} size="20px" />
							<Text padding="0" margin="0">
								Compete with Friends
							</Text>
						</Box>
						<Box margin="0px 0px 0px 0px" display="flex" grid-gap="10px">
							<Icon display="block" category="md" icon={MdCheckCircle} size="20px" />
							<Text padding="0" margin="0">
								Relaxing Yet Challenging
							</Text>
						</Box>
					</List>
				</Box>
				<Button
					border-width="1px"
					border-style="solid"
					border-color="--color-primary"
					border-radius="13px"
					background="--primaryGradient"
					type="link"
					text-decoration-line="initial"
					href="https://play.google.com/store/apps/details?id=com.ketchapp.stack&hl=en"
					text-align="center"
					margin="2rem 0px 0px 0px"
				>
					Download
				</Button>
			</Box>
		</Section>
		<Components.Footer4>
			<Override slot="link3" />
			<Override slot="link4" />
		</Components.Footer4>
		<RawHtml>
			<style place={"endOfHead"} rawKey={"673f25879e74900024fead27"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"}
			</style>
		</RawHtml>
	</Theme>;
});